module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_photogallery_3.a3dede82.jpg";